export const SET_ACTIVE_ERROR = "SET_ACTIVE_ERROR"